
    <div class="promo-container" *ngIf="canParticipate()">
      <div *ngFor="let promo of promos">
        <h3>Promoção</h3>
        <ng-promo-details
            [promo]="promo"
            [showImage]="false">
        </ng-promo-details>
      </div>
    </div>
  